import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AdminRoutes from './routes/Admin/Routes';

const FallbackComponent = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 vw-100 flex-column gap-3">
      <p className="fs-2">400 | 何かがうまくいきませんでした</p>

      <button type="button" className="btn btn-primary" onClick={() => (window.location.href = '/')}>
        ホームに戻る
      </button>
    </div>
  );
};

const RoutesApp = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/*"
          element={
            <ErrorBoundary
              fallback={<FallbackComponent />}
              onError={(error: Error, info: React.ErrorInfo) => {
                console.log('ErrorBoundary:: ', { error, info });
              }}
            >
              <AdminRoutes />
            </ErrorBoundary>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesApp;
